export default __webpack_public_path__ + "static/media/case-study-5-type-23-readiness.015abcdd.mp4";